/**
 * @todo This should be exported from @ftdr/blueprint_core
 * and auto generated based on class names used in component_css
 */
export const CSS_CLASSES = {
  DATE_TIME_INPUT_WRAPPER: "date-time-input-wrapper",
  DATE_TIME_INPUT_DATE: "date-time-input-date",
  DATE_TIME_INPUT_POPOVER: "date-time-input-popover",
  DATE_TIME_INPUT_POPOVER_CLOSED: "date-time-input-popover-closed",
  DATE_TIME_INPUT_CALENDAR: "date-time-input-calendar",
  DATE_TIME_INPUT_MONTH: "date-time-input-month",
  DATE_TIME_INPUT_MONTH_HEADER: "date-time-input-month-header",
  DATE_TIME_INPUT_MONTH_TITLE: "date-time-input-month-title",
  DATE_TIME_INPUT_WEEKS: "date-time-input-weeks",
  DATE_TIME_INPUT_WEEK: "date-time-input-week",
  DATE_TIME_INPUT_DAY: "date-time-input-day",
  DATE_TIME_INPUT_DAY_OUTSIDE_OF_MONTH: "date-time-input-day-outside-of-month",
  DATE_TIME_INPUT_DAY_PRE_SELECTED: "date-time-input-day-pre-selected",
  DATE_TIME_INPUT_DAY_SELECTED: "date-time-input-day-selected",
  DATE_TIME_INPUT_DAY_DISABLED: "date-time-input-day-disabled",
  DATE_TIME_INPUT_DAY_RANGE_START: "date-time-input-day-range-start",
  DATE_TIME_INPUT_DAY_RANGE_END: "date-time-input-day-range-end",
  DATE_TIME_INPUT_DAY_IN_RANGE: "date-time-input-day-in-range",
  DATE_TIME_INPUT_DAY_SELECTION_RANGE_START: "date-time-input-day-selection-range-start",
  DATE_TIME_INPUT_DAY_SELECTION_RANGE_END: "date-time-input-day-selection-range-end",
  DATE_TIME_INPUT_DAY_SELECTION_IN_RANGE: "date-time-input-day-selection-in-range",
  DATE_TIME_INPUT_WITH_TIME: "date-time-input-with-time",

  DATE_TIME_INPUT_RANGE_WRAPPER: "date-time-input-range-wrapper",
  DATE_TIME_INPUT_RANGE_FOCUS: "date-time-input-range-focus",
  DATE_TIME_INPUT_RANGE_START_INPUT: "date-time-input-range-start-input",
  DATE_TIME_INPUT_RANGE_END_INPUT: "date-time-input-range-end-input",
  DATE_TIME_INPUT_RANGE_DIVIDER: "date-time-input-range-divider",

  DATE_TIME_INPUT_TIME: "date-time-input-time",
  DATE_TIME_INPUT_TIME_HOURS_MINUTES: "date-time-input-time-hours-minutes",
  DATE_TIME_INPUT_DIVIDER: "date-time-input-divider",
  DATE_TIME_INPUT_HOURS_INPUT: "date-time-input-hours-input",
  DATE_TIME_INPUT_MINUTES_INPUT: "date-time-input-minutes-input",

  DATE_TIME_INPUT_MERIDIAN: "date-time-input-meridian",
};
